var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Usuários","p-read-link":"user.read.one","p-create-link":"user.create","p-name":"users"}})}
var staticRenderFns = []

export { render, staticRenderFns }